import React, { useState } from "react";
import { useStaticQuery, graphql, Link } from "gatsby"
import "./PropertyCard.scss"
//import ImageModule from "../../modules/image_module";
import ImageCallBack from "../../modules/image-callback-module";

import { propertyDetailUrl, GetPrice, getAgentId } from "../../common/utils/property_utils";
import SearchResultsImagePopup from "../SalesCard/SearchResultsImagePopup"
import { SaveItem } from "@starberry/myaccount-website-utils"
import { HeartIcon } from "../../common/icons";
import { PageLinks } from "../../common/page-links";

import { CurrConvertPrice } from '../CurrencyConverter/CurrConvertPrice'
import { useGlobalState } from '../GlobalState/GlobalStateProvider';

const FeaturesCard = (props) => {
    const { currState } = useGlobalState();

    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const data = useStaticQuery(graphql`
        query OfficeQueryFeat{
            glstrapi {
                offices {
                    office_crm_id
                    mobile
                    email
                }
            }
        }`)

    var offices = data.glstrapi?.offices;

    const openLighboxMobile = (e, ind) => {
        e.preventDefault();
        setPhotoIndex(ind);
        setIsOpen(true);
    }
    

    const FeaturesList = props.FeaturesList;

    var image_url = FeaturesList?.images?.length > 0 ? FeaturesList.images[0].url : "";

    //console.log("FeaturesList ====>", FeaturesList?.department, FeaturesList?.search_type, FeaturesList?.status, FeaturesList?.slug, FeaturesList?.id)

    var property_url = propertyDetailUrl(FeaturesList?.department, FeaturesList?.search_type, FeaturesList?.status, FeaturesList?.slug, FeaturesList?.id);

    var contact_investment_url = property_url
    if(FeaturesList?.officeDepartment === "investments"){
        contact_investment_url = `/${PageLinks.contact_investment_centre}/`
    }
    var property_id = FeaturesList.id

    var currency = process.env.GATSBY_CURRENCY;
    // let processedImages = JSON.stringify({});
    // if (FeaturesList?.imagetransforms?.images_Transforms) {
    //     processedImages = FeaturesList?.imagetransforms?.images_Transforms;
    // }

    var images_filter = FeaturesList?.images?.length > 0 && FeaturesList?.images?.filter(img => img.url !== null)
    
    const ImageRenderList = ({item, imagename}) => {
        let processedImages = JSON.stringify({});
        if (item?.imagetransforms?.images_Transforms) {
            processedImages = item?.imagetransforms?.images_Transforms;
        }

        
        return (
        //   <ImageModule ImageSrc={images_filter.length > 0 ? images_filter[0] : ""} title={item.display_address} altText={item.display_address} imagetransforms={processedImages} renderer="srcSet" imagename={imagename} strapi_id={item.id} classNames="" ggfx_results={item?.ggfx_results} />        
          
          <ImageCallBack 
            processedImages={processedImages} 
            imageSrc={images_filter.length > 0 ? images_filter[0] : ""} 
            imagename={imagename} 
            strapi_id={item.id}
            altText={`${item.display_address}`}
            renderer="srcSet"
            classNames=""
            ggfx_results={item?.ggfx_results}
            />  
        )
    }

    //console.log("FeaturesList_price", CurrConvertPrice(FeaturesList.price))

    let price_convert = CurrConvertPrice(FeaturesList.price);
    let price_convert_ppw = CurrConvertPrice(FeaturesList.price*12/52/FeaturesList.bedroom);

    var pppw = FeaturesList.price > 0 && parseInt(FeaturesList.bedroom) > 0 ? price_convert_ppw+"/PPPW" : price_convert+"/PM";


    var book_a_viewing_link = process.env.GATSBY_BOOK_VIEWING_LINK;
    var agent_id = getAgentId(FeaturesList?.office_crm_id);

    if(process.env.GATSBY_BOOK_VIEWING_LINK){
        book_a_viewing_link = book_a_viewing_link.replace('{agent_id}', agent_id).replace('{unique_id}', FeaturesList?.crm_id)
    }


    let officeContact = _.find(offices, function (o) { return _.includes(_.split(o.office_crm_id, ','), FeaturesList?.office_crm_id); });
    
    var to_email_id = process.env.GATSBY_BOOK_VIEWING_EMAIL ? process.env.GATSBY_BOOK_VIEWING_EMAIL : officeContact?.email ? officeContact?.email : "";
    
   // console.log("selling_info", FeaturesList?.selling_info)

   let rental_yield = FeaturesList?.selling_info?.estimatedMonthlyRetailValue
   ? parseFloat((FeaturesList?.selling_info?.estimatedMonthlyRetailValue) * 12 /  FeaturesList?.selling_info?.recommendedPrice * 100).toFixed(2) : 0


    return (
        <React.Fragment>
            <div className="slide-wrapper">
                <div className="slide-img ">

                    {<Link to={contact_investment_url} state={{ property_data:{...FeaturesList}, form_type: "investment_centre", property_url: property_url, to_email_id }} >
                        {/* <ImageModule ImageSrc={{ url: image_url, alternativeText: FeaturesList.display_address }} imagename={"property.images.list_view"} imagetransforms={processedImages} renderer="srcSet" strapi_id={FeaturesList.id} /> */}

                        <ImageRenderList item={FeaturesList} imagename={"property.images.list_view"} />
                    </Link>
                    }

                    {process.env.GATSBY_SITE_NAME === "Charters" && 
                        <SaveItem type="property" pid={property_id} userObjects={props.userObjects}>
                            <span className="map-info save-item">
                                <HeartIcon /><span> Save</span><span className="saved-text">d</span>
                            </span>
                        </SaveItem>
                    }

                    {FeaturesList?.extra?.officeDepartment === "Prestige" ?
                        <span className="top-text prestige_bg">Hardisty <span className="prestige_clr">Prestige</span></span>
                        :
                        FeaturesList?.extra?.officeDepartment === "Collection" ? 
                            (
                                process.env.GATSBY_SITE_NAME === "John Shepherd" ?
                                    <span className="top-text collection_bg">John Shepherd <span className="collection_clr">Collection</span></span> 
                                : 
                                    <span className="top-text collection_bg"><span className="collection_clr">Collection</span></span> 
                            )
                            
                        : ""
                    }

                    {FeaturesList?.officeDepartment !== "investments" && 
                        (FeaturesList.status !== "For Sale" && FeaturesList.status !== "To Let") ? <span className={`top-text ${FeaturesList?.extra?.officeDepartment}`}>{FeaturesList.status} </span> : ''
                    }

                    {images_filter?.length > 0 &&
                        <span className="bottom-text" onClick={(e) => openLighboxMobile(e, 0)}>
                            <i className="gallery-icon"></i>
                            <span className="text">{images_filter?.length}</span>
                        </span>
                    }
                    {/* <SaveItem type="property" pid={FeaturesList.id}>
                        <span className="save-item">
                            <HeartIcon /><span> Save</span><span className="saved-text">d</span>
                        </span>
                    </SaveItem> */}
                </div>
                <div className="slide-content">
                    {/* {FeaturesList?.officeDepartment === "investments" &&
                        <span className="h5"><Link to={property_url} state={{ property_data:{...FeaturesList, address:FeaturesList.display_address}, form_type: "investment_centre", property_url: property_url, to_email_id }}>{FeaturesList.title}</Link></span>
                    } */}

                    <div className="content">
                        <Link to={contact_investment_url} state={{ property_data:{...FeaturesList}, form_type: "investment_centre", property_url: property_url, to_email_id }}>
                        {process.env.GATSBY_SITE_NAME === "BV Students" ? 
                            <span className="highlight-text">{pppw}</span>
                        : (process.env.GATSBY_SITE_NAME === "Brandvaughan" && FeaturesList?.officeDepartment === "Student") ? 
                            <span className="highlight-text">{pppw}</span>
                        : process.env.GATSBY_SITE_NAME === "Sinclair" ? <>
                                <span className="highlight-text">{price_convert}</span>
                                <span className="sm-text">pppw</span>
                            </>
                        :
                        (FeaturesList?.price > 0 || FeaturesList?.price_qualifier) &&
                            <>
                                {FeaturesList.price > 0 &&
                                    <span className="highlight-text">{price_convert}</span>
                                }
                                {(FeaturesList?.price_qualifier !== "Offers in the region of") &&
                                    <span className="sm-text">{FeaturesList.price_qualifier}</span>
                                }
                            </>
                        }
                        </Link>
                    </div>

                    <h3>
                        <Link to={contact_investment_url} state={{ property_data:{...FeaturesList}, form_type: "investment_centre", property_url: property_url, to_email_id }}>{FeaturesList.display_address}</Link>
                        {process.env.GATSBY_SITE_NAME === "Charters" && <span>{FeaturesList.title}</span>}
                    </h3>

                    {FeaturesList?.officeDepartment === "investments" &&
                        (
                            process.env.GATSBY_SITE_NAME === "D. J. Alexander" ?
                            <>
                                {/* <span className="sm-text investment">YOA Avg. Rental Price</span>
                                <span className="sm-text investment mb-2">RIOA Avg. Rental Yield</span> */}

                                <span className="sm-text investment"><b>{GetPrice(FeaturesList?.selling_info?.estimatedMonthlyRetailValue)}</b>&nbsp;Avg. Rental Price</span>
                                <span className="sm-text investment mb-2"><b>{rental_yield}%</b>&nbsp;Avg. Rental Yield</span>
                            </>
                            :
                            <>
                                <span className="sm-text investment"><b>{GetPrice(FeaturesList?.selling_info?.estimatedMonthlyRetailValue)}</b>&nbsp;Avg. Rental Price</span>
                                <span className="sm-text investment mb-2"><b>{FeaturesList?.selling_info?.grossYieldPercentage || 0}%</b>&nbsp;Avg. Rental Yield</span>
                            </>
                        )
                    }

                    <div className="icon-wrapper">
                        {FeaturesList.property_type && 
                        <div className="icon-wrap property_type">
                            <span className="count">{FeaturesList.property_type}</span>
                        </div>
                        }

                        {parseInt(FeaturesList.bedroom) > 0 ?
                            <div className="icon-wrap">
                                <i className="icon-bed"></i>
                                <span className="count">{FeaturesList.bedroom}</span>
                            </div>
                            :""
                        }

                        {parseInt(FeaturesList.bathroom) > 0 ?
                            <div className="icon-wrap">
                                <i className="icon-bath"></i>
                                <span className="count">{FeaturesList.bathroom}</span>
                            </div>
                            :""
                        }

                        {parseInt(FeaturesList.reception) > 0 ?
                            <div className="icon-wrap">
                                <i className="icon-reception"></i>
                                <span className="count">{FeaturesList.reception}</span>
                            </div>
                            :""
                        }

                        {/* {item.hasParking === true &&
                            <div className="icon-wrap">
                                <a href="javascript:;">
                                    <i className="icon-parking"></i>
                                </a>
                                <span className="count">Parking</span>
                            </div>
                        } */}
                    </div>
                    
                    {FeaturesList?.officeDepartment !== "investments" && 
                    <div className="nego_details">

                        {(process.env.GATSBY_BOOK_VIEWING_LINK && FeaturesList?.search_type === "lettings" && agent_id) ?
                            <a href={"javascript:;"} onClick={() => {props.setModalShow(true); props.setViewingLink(book_a_viewing_link)}} data-link={book_a_viewing_link} className="map-info book-viewing">
                                <i className="icon-mail"></i>
                                <span>Email</span>
                            </a>
                        :
                            <Link to={`/${PageLinks.book_a_viewing}/`} state={{ property_data:{...FeaturesList}, form_type: "book_a_viewing", property_url: property_url, to_email_id }} className="map-info book-viewing">
                                <i className="icon-mail"></i>
                                <span>Email</span>
                            </Link>
                        }

                        {officeContact?.mobile && 
                            <a href={`tel:${officeContact?.mobile}`} className="map-info call">
                                <i className="icon-phone"></i>
                                <span>Call</span>
                            </a>
                        }

                        <SaveItem type="property" pid={property_id} userObjects={props.userObjects}>
                            <span className="map-info save-item">
                                <HeartIcon /><span> Save</span><span className="saved-text">d</span>
                            </span>
                        </SaveItem>
                    </div>
                    }

                </div>
            </div>

            {isOpen && (images_filter && images_filter.length != 0) && (
                <SearchResultsImagePopup
                    propertyId={FeaturesList.id}
                    propertyImage={images_filter}
                    photoIndex={photoIndex}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    largeSize="720x380"
                    largeSize2="570x374"
                    img_type={"no_property"}
                />
            )}
        </React.Fragment>
    );
};

export default FeaturesCard;
